import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { paths } from '@mc/paths'
import { useStaticData } from '@mc/static-data-react'
import { CHECKOUT_I18N_NAMESPACE, i18nInstance } from '../../../../i18n'
import { useNavigationSteps } from '../../useNavigationSteps'

const LogInComp = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()

  const {
    context: { hideNavbarElements },
  } = useNavigationSteps()

  if (isLoggedIn || hideNavbarElements) {
    return null
  }

  const onClick = () => {
    window.location.href = paths.logIn(window.location.href)
  }

  return (
    <button
      onClick={onClick}
      className='mc-text-h7 mc-clickable'
      role='link'
      type='button'
    >
      {t('nav.cta.login')}
    </button>
  )
}

export const LogIn = withI18nContext(i18nInstance)(LogInComp)
